import { apiClient } from './client'
import type { ApiResponse } from './client'
import type { SalesforceConnectionStatus, SalesforceAuthInitiateResult } from '@/types/salesforce'

export const salesforceApi = {
    /** Get OAuth authorization URL to open in popup */
    initiate: (): Promise<ApiResponse<SalesforceAuthInitiateResult>> =>
        apiClient.get('/api/Auth/Salesforce/Initiate'),

    /** Check Salesforce connection status for a company */
    getStatus: (clientCompanyId: string): Promise<ApiResponse<SalesforceConnectionStatus>> =>
        apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Integrations/Salesforce/Status`),

    /** Disconnect Salesforce for a company */
    disconnect: (clientCompanyId: string): Promise<ApiResponse<void>> =>
        apiClient.post(`/api/ClientCompanies/${clientCompanyId}/Integrations/Salesforce/Disconnect`, {}),
}
